<template>
  <GlobalAlertWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="110px" label-suffix="：" inline>

      <el-form-item label="分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入分类名称" v-trim/>
      </el-form-item>
      <el-form-item label="图标" prop="imgurlfull">
        <UploadAvatarImage
            :uploadData="{folder:'labels'}"
            :file="{ 'imgurlfull': form.imgurlfull, 'imgurl': form.imgurl }"
            @uploadSuccess="uploadAvatarSuccess"
            @uploadEnd="isUploading=false"
            @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="排序码(升序)" prop="sortnum">
        <el-input v-model="form.sortnum" type="number"  placeholder="请输入排序码" v-trim/>
      </el-form-item>

    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
export default {
  name: 'OperaProductLabelWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow,UploadAvatarImage },
  data () {
    return {
      // 表单数据
      isUploading: false,
      form: {
        id: null,
        name: '',
        module: 0,
        type: '0',
        imgurl:null,
        imgurlfull:null,
        sortnum: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入分类名称', tigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择所属板块', tigger: 'change' }
        ],
      }
    }
  },
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  },
  methods: {
    // 上传图片
    uploadAvatarSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgurlfull = file.imgurlfull;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
